import React, { useEffect, useState } from "react";
import { useStyles } from "../style";
import { toast } from "react-toastify";
import { Grid, TextField, MenuItem, InputLabel, Typography, Button, Select } from "@material-ui/core";
import { BootstrapInput } from "containers/labs/style";
import { getSelectedIdFromArray } from "utils/common";
import { useForm } from "hooks/useForm";
import ConsoleService from "services/admin/masters/Console";
import { MSG_ADD_SUCCESS, MSG_UPDATE_SUCCESS } from "constants/admin/masters/users";
import Modal from 'components/Modal';


import uuid from 'react-uuid';

const consoleServiceObj = new ConsoleService();

const VAppConsole = (props) => {
    const classes = useStyles();
    const { setActiveBtn, setActivateButton, vAppId, labId, checkActiveConsoleScreen } = props;
    const [cloudTypeData] = useState([{  id: 1, label: 'SkyTap', value: 'SkyTap' }]);
    const [consoleTypeData] = useState([{ id: 1, label: 'RDP', value: 'RDP' }]);
    const [templateTypeData, setTemplateTypeData] = useState([]);
    // const [labConsoleAccessTypeData, setLabConsoleAccessType] = useState([]);
    const [vmAccess, setVmAccess] = useState([]);
    const [vmObjectId, setVmObjectId] = useState()
    const [validateVMAccess, setValidateVMAccess] = useState(false);

    const initialFormData = { // used to initialize the data
        cloud_type_id: 1,
        console_type_id: "RDP",
        name: '',
        template_id: 0,
        lab_console_access_type_id: 1,
        updated_by: '',
        login: '',
        password: '',
        max_instances: 1,
        sort_order: 0,
    };

    const { data, populateForm, handleSubmit, handleChange, handleChangeCustom } = useForm({
        initialValues: initialFormData,
        onSubmit: () => { submitForm(data) }
    });

    useEffect(() => {
        let templateList = [{ label: '--Select--', value: 0 }];
      

        consoleServiceObj.getTemplateList().then((response) => {
            const { templates } = response;
            templates && templates.length > 0 && templates.forEach(element => {
                templateList.push({ label: element.name, value: element.id });
            });
            setTemplateTypeData(templateList);
        }).catch(error => {
            console.log(error)
        });

        consoleServiceObj.getALLVmAccess(labId).then((response) => {
            if (response.results[0].vm_details.length === 1) {
                const element = response.results[0].vm_details[0]
                element.include = true;
                element.exclude = false;
                setVmAccess(response.results[0].vm_details.map(el => el.name === element.name ? element : el))
            } else {

                setVmAccess(response.results[0].vm_details)
            }

            setVmObjectId(response.results[0].id)
        }).catch(error => {
            console.log(error)
        })

    }, [labId]);

    useEffect(() => {
        let params = {
            id: vAppId
        }
        consoleServiceObj.getById(params).then((response) => {
            const { container_lab_item_id } = response;
            initialFormData.cloud_type_id = response?.cloud_type_id || 1;
            initialFormData.console_type_id = response?.type || "RDP";
            initialFormData.name = response?.name || '';
            initialFormData.template_id = response?.template || 0;
            initialFormData.lab_console_access_type_id = response.lab_console_access_type_id || 1;
            initialFormData.updated_by = response?.updated_by || '';
            initialFormData.login = response?.login || '';
            initialFormData.password = response?.password || '';
            initialFormData.max_instances = response?.max_parallel_session || 0;
            initialFormData.sort_order = response?.sort_order || 0;
            populateForm(initialFormData);
        }).catch(error => {
            console.log(error)
        });
        // eslint-disable-next-line
    }, [vAppId]);

    const handleCancel = () => {
        setActiveBtn('')
        checkActiveConsoleScreen('');
    };

    const submitForm = async (data) => {
      let params =   {
            name: data.name,
            lab: labId,
            template: data.template_id,
            max_parallel_session:data.max_instances
        
        }
        let response, vmAccessResponse;
        validateVMAccess === false ? setValidateVMAccess(vmAccess.every(function (element) {
            return element.exclude === true
        })) : setValidateVMAccess(false)
       let vmCheckExclude = vmAccess.every(function (element) {
            return element.exclude === true
        })
        if (validateVMAccess || vmCheckExclude === false ) {
            if (vAppId > 0) {
                response = await consoleServiceObj.update(params, vAppId);
                if (vmObjectId) {
                    vmAccessResponse = await consoleServiceObj.updateAllVmAcces([{ vm_details: vmAccess }], vmObjectId)
                } else {
                    /// for old labs if vmaccess id is not present while edit, will create the new vmaccess id
                    vmAccessResponse = await consoleServiceObj.setAllVmAcces({ lab: labId, vm_details: vmAccess })
                }

            } else {
                response = await consoleServiceObj.create(params);
                vmAccessResponse = await consoleServiceObj.setAllVmAcces({ lab: labId, vm_details: vmAccess })

            }
            if (response && vmAccessResponse) {
                toast.success(response.message || (vAppId > 0) ? MSG_UPDATE_SUCCESS : MSG_ADD_SUCCESS);
                setActiveBtn('');
                setActivateButton(false)
                checkActiveConsoleScreen('')
            }
        }


    }

    const handleChangeTemplateVmAccess = (value) => {
        consoleServiceObj.getAllTemplateVM(value).then((response) => {
            let VM_ACCESS = response?.template_details.vms.map((v1) => {
                return { name: v1.name, include: true, exclude: false }
            })
            setVmAccess(VM_ACCESS)
        })
            .catch((error) => {
                console.log(error)
            })
    }

    const setRadioButtonChecked = (event) => {
        let element = {}, updatedItems = [];
        if (event.target.id === "Include") {
            element = vmAccess.find((v1) => v1?.name === event.target.name)
            element.include = true
            element.exclude = false
            updatedItems = vmAccess.map(el => el.name === element.name ? element : el)
            setVmAccess(updatedItems)
        } else {
            element = vmAccess.find((v1) => v1?.name === event.target.name)
            element.include = false
            element.exclude = true
            updatedItems = vmAccess.map(el => el.name === element.name ? element : el)
            setVmAccess(updatedItems)
        }
    }
const handleLabVmAccess = () =>{
    setValidateVMAccess(true);
    handleSubmit()
}
    return (
        <>
            <div onSubmit={handleSubmit}>
                {
                    validateVMAccess ? <Modal closeModalPopup={() => { setValidateVMAccess(false) }}
                        type={"vmAccess"}
                        handleLabVmAccess={handleLabVmAccess} /> : <></>
                }
                <Grid item xs={12} className={classes.gridOutline} >
                    <Typography color="textPrimary" className={classes.subheader}>General</Typography>
                    <Grid style={{ display: 'flex', justifyContent: 'space-between' }} item xs={12} >
                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Cloud Type</InputLabel>
                            <Select
                                input={<BootstrapInput />}
                                value={cloudTypeData && cloudTypeData.length > 0 && getSelectedIdFromArray(cloudTypeData, "SkyTap")}
                                className={classes.select}
                                onChange={(event) => {
                                    handleChangeCustom('cloud_type_id', event.target.value)
                                }
                                }
                            >
                                {cloudTypeData.map((option, index) => {
                                    return (
                                        <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </Grid>

                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Console Type</InputLabel>
                            <Select
                                input={<BootstrapInput />}
                                value={consoleTypeData && consoleTypeData.length > 0 && getSelectedIdFromArray(consoleTypeData, "RDP")}
                                className={classes.select}
                                onChange={(event) => {
                                    handleChangeCustom('console_type_id', event.target.value)
                                }
                                }
                            >
                                {consoleTypeData.map((option, index) => {
                                    return (
                                        <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </Grid>

                    </Grid>

                    <Grid style={{ display: 'flex', justifyContent: 'space-between' }} item xs={12} >
                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Name</InputLabel>
                            <TextField fullWidth
                                name="name"
                                variant="outlined"
                                value={data.name}
                                onChange={handleChange('name')}
                                classes={{ root: classes.consoleTextField }}
                                InputProps={{
                                    classes: {
                                        input: classes.consoleInputField,
                                        root: classes.consoleBase,
                                        focused: classes.focused,
                                        notchedOutline: classes.notchedOutline
                                    },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#2a2c2e' },
                                }}
                            />
                        </Grid>
                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Template</InputLabel>
                            <Select
                                input={<BootstrapInput />}
                                value={templateTypeData && templateTypeData.length > 0 && getSelectedIdFromArray(templateTypeData, data.template_id)}
                                className={classes.select}
                                onChange={(event) => {
                                    handleChangeCustom('template_id', event.target.value)
                                    handleChangeTemplateVmAccess(event.target.value)
                                }
                                }
                            >
                                {templateTypeData.map((option, index) => {
                                    return (
                                        <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </Grid>
                    </Grid>


                    <Grid style={{ display: 'flex', justifyContent: 'space-between' }} item xs={12} >

                        {/* <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Lab Console Access Type</InputLabel>
                            <Select
                                input={<BootstrapInput />}
                                value={labConsoleAccessTypeData && labConsoleAccessTypeData.length > 0 && getSelectedIdFromArray(labConsoleAccessTypeData, data.lab_console_access_type_id)}
                                className={classes.select}
                                onChange={(event) => {
                                    handleChangeCustom('lab_console_access_type_id', event.target.value)
                                }
                                }
                            >
                                {labConsoleAccessTypeData.map((option, index) => {
                                    return (
                                        <MenuItem key={uuid()} className={classes.menuItem} value={option.value}>{option.label}</MenuItem>
                                    );
                                })}
                            </Select>
                        </Grid> */}

                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Last Modified By</InputLabel>
                            <TextField fullWidth
                                name="name"
                                variant="outlined"
                                value={data.updated_by}
                                readonly
                                classes={{ root: classes.consoleTextField }}
                                InputProps={{
                                    classes: {
                                        input: classes.consoleInputField,
                                        root: classes.consoleBase,
                                        focused: classes.focused,
                                        notchedOutline: classes.notchedOutline
                                    },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#2a2c2e' },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {/* <Grid item xs={12} className={classes.gridOutline} >
                    <Typography color="textPrimary" className={classes.subheader}>Credentials</Typography>
                    <Grid style={{ display: 'flex', justifyContent: 'space-between' }} item xs={12} >
                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Login</InputLabel>
                            <TextField fullWidth
                                name="login"
                                variant="outlined"
                                value={data.login}
                                onChange={handleChange('login')}
                                classes={{ root: classes.consoleTextField }}
                                InputProps={{
                                    classes: {
                                        input: classes.consoleInputField,
                                        root: classes.consoleBase,
                                        focused: classes.focused,
                                        notchedOutline: classes.notchedOutline
                                    },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#2a2c2e' },
                                }}
                            />
                        </Grid>
                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Password</InputLabel>
                            <TextField fullWidth
                                name="password"
                                variant="outlined"
                                value={data.password}
                                onChange={handleChange('password')}
                                type='password'
                                classes={{ root: classes.consoleTextField }}
                                InputProps={{
                                    classes: {
                                        input: classes.consoleInputField,
                                        root: classes.consoleBase,
                                        focused: classes.focused,
                                        notchedOutline: classes.notchedOutline
                                    },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#2a2c2e' },
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid> */}

                {
                    vmAccess.length > 1 &&
                    <Grid item xs={12} className={classes.gridOutline}>
                        <Typography color="textPrimary" className={classes.subheader}>VM Permission</Typography>
                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <InputLabel className={classes.selectLabel} style={{ paddingBottom: "10px" }}>VM Name</InputLabel>
                            </Grid>
                            <Grid item xs={2}>
                                <InputLabel className={classes.selectLabel} >Include</InputLabel>
                            </Grid>
                            <Grid item xs={2}>
                                <InputLabel className={classes.selectLabel} >Exclude</InputLabel>
                            </Grid>

                        </Grid>
                        {
                            vmAccess.map((v1) => {
                                return (
                                    <>
                                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <InputLabel style={{ paddingBottom: "10px", paddingLeft: "35px" }} className={classes.selectLabel} >{v1?.name}</InputLabel>
                                            </Grid>
                                            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                                <input type="radio" id={"Include"} value={v1?.include} name={v1?.name} checked={v1?.include} onChange={(event) => { setRadioButtonChecked(event) }} />
                                            </Grid>
                                            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                                <input type="radio" id={"Exclude"} value={v1?.exclude} name={v1?.name} checked={v1?.exclude ? true : false} onChange={(event) => { setRadioButtonChecked(event) }} />
                                            </Grid>
                                        </Grid>

                                    </>
                                )
                            })
                        }



                    </Grid>
                }

                {
                    vmAccess.length === 1 &&
                    <Grid item xs={12} className={classes.gridOutline}>
                        <Typography color="textPrimary" className={classes.subheader}>VM Permission</Typography>
                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Grid item xs={2}>
                                <InputLabel className={classes.selectLabel} style={{ paddingBottom: "10px" }}>VM Name</InputLabel>
                            </Grid>
                            <Grid item xs={2}>
                                <InputLabel className={classes.selectLabel} >Include</InputLabel>
                            </Grid>
                        </Grid>
                        {
                            vmAccess.map((v1) => {
                                return (
                                    <>
                                        <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <Grid item xs={6} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <InputLabel style={{ paddingBottom: "10px", paddingLeft: "35px" }} className={classes.selectLabel} >{v1?.name}</InputLabel>
                                            </Grid>
                                            <Grid item xs={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                                <input type="radio" id={"Include"} value={v1?.include} name={v1?.name} checked={true} onChange={(event) => { setRadioButtonChecked(event) }} />
                                            </Grid>
                                        </Grid>

                                    </>
                                )
                            })
                        }



                    </Grid>
                }
                <Grid item xs={12} className={classes.gridOutline} >
                    <Typography color="textPrimary" className={classes.subheader}>Others</Typography>
                    <Grid style={{ display: 'flex', justifyContent: 'space-between' }} item xs={12} >

                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Max Instances</InputLabel>
                            <TextField fullWidth
                                name="instances"
                                variant="outlined"
                                type='number'
                                onChange={handleChange('max_instances')}
                                value={data.max_instances}
                                classes={{ root: classes.consoleTextField }}
                                InputProps={{
                                    classes: {
                                        input: classes.consoleInputField,
                                        root: classes.consoleBase,
                                        focused: classes.focused,
                                        notchedOutline: classes.notchedOutline,
                                    },
                                }}
                                inputProps={{ min: 0 }}

                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#2a2c2e' },
                                }}
                            />
                        </Grid>

                        <Grid item xs={5} style={{ display: 'flex', }}>
                            <InputLabel className={classes.selectLabel} >Order</InputLabel>
                            <TextField fullWidth
                                name="order"
                                variant="outlined"
                                type='number'
                                value={data.sort_order}
                                onChange={handleChange('sort_order')}
                                classes={{ root: classes.consoleTextField }}
                                InputProps={{
                                    classes: {
                                        input: classes.consoleInputField,
                                        root: classes.consoleBase,
                                        focused: classes.focused,
                                        notchedOutline: classes.notchedOutline
                                    },
                                }}
                                inputProps={{ min: 0 }}
                                InputLabelProps={{
                                    shrink: true,
                                    style: { color: '#2a2c2e' },
                                }}
                            />
                        </Grid>

                    </Grid>
                    <Grid item xs={6} className={classes.gridOutline}>
                        <Button
                            className={classes.cancelBtn}
                            onClick={handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            className={classes.saveBtn}
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default VAppConsole;